export default __webpack_public_path__ + "static/char-thumb-48-1724e05ecdc31d9d067ead27038ac541.webp";